export default __webpack_public_path__ + "static/loans-to-go-logo-old-0c3137d32a06849da6c2ab1a5045464f.webp";